module.exports = __webpack_public_path__ + "40f483d6f7ef034dee114865ce30a6e3.woff";


//////////////////
// WEBPACK FOOTER
// ./~/mdi/fonts/materialdesignicons-webfont.woff?v=2.2.43
// module id = 955
// module chunks = 1